import styled from 'styled-components';
import { IonCheckbox, IonLabel } from '@ionic/react';

export const Checkbox = styled(IonCheckbox)``;

export const Label = styled(IonLabel)`
  white-space: normal !important;
`;
